import BaseSubscriberService from './baseSubscriberService';

export default class ErrorService extends BaseSubscriberService {
  constructor() {
    super();
  }

  showError(errorText) {
    this.broadcast(errorText);
  }
}
